import cx from "classnames"
import React from "react"
import closeIcon from "./close-icon.svg"
import * as css from "./DesktopCategoryFilter.module.css"

function DesktopCategoryFilter({
  className,
  primaryCategories,
  secondaryCategories,
  active,
  onSelectItem,
}) {
  const renderItem = (clsName, category, index) => (
    <li
      className={cx(clsName, {
        [css.active]: active === category,
      })}
      onClick={() => onSelectItem(category)}
      role="button"
      key={index}
    >
      {category}
    </li>
  )

  return (
    <div className={cx(css.root, className)}>
      <ul className={css.list}>
        <li className={css.title}>Sort by category</li>
        {primaryCategories?.map((category, index) =>
          renderItem(css.item, category, index)
        )}
        {secondaryCategories?.length > 0 && (
          <li
            className={cx(css.item, {
              [css.active]: secondaryCategories?.includes(active),
            })}
          >
            More <span className={css.arrow} />
            <div className={css.dropdown}>
              <ul className={css.sublist}>
                {secondaryCategories?.map((category, index) =>
                  renderItem(css.subitem, category, index)
                )}
              </ul>
            </div>
          </li>
        )}
      </ul>
      {active && (
        <button
          className={css.clearButton}
          onClick={() => onSelectItem(null)}
          type="button"
        >
          Clear selection
          <span className={css.closeIcon}>
            <img src={closeIcon} alt="Close icon" />
          </span>
        </button>
      )}
    </div>
  )
}

export default DesktopCategoryFilter
